module.exports = __webpack_public_path__ + "static/media/muscle.c0803b34.svg";


//////////////////
// WEBPACK FOOTER
// ./src/images/muscle.svg
// module id = 2101
// module chunks = 0